import {makeAutoObservable} from "mobx";
import {
    acceptPolicyRequest,
    enrollUserRequest,
    getMe,
    getUserByHeader,
    sendSubscribeRequest,
    setNameAndRoleRequest,
} from "../requests";
import {logEvent, once, reprNetworkError} from "../utils";

const authTrigger = once()

export class UserStore {

    user = null
    isLoading = true
    token = null


    constructor(root) {
        this.root = root;
        this.token = localStorage.getItem("token")
        makeAutoObservable(this);
    }

    auth = async (token) => {
        if (!authTrigger()) return;
        try {
            console.log("Auth")
            this.isLoading = true
            localStorage.setItem("token", token)
            const user = await getUserByHeader()
            localStorage.setItem('itsai_user_id', user.username);
            localStorage.setItem('id', user.username);
            await this.refresh()
            console.log("auth set token", token)
            this.token = token
            this.isLoading = false
        } catch (e) {
            this.setError('Internet connection error: ' + reprNetworkError(e))
        }
    }

    refresh = async () => {
        const userData = await getMe();
        if (typeof userData === 'string') {
            this.setError(userData)
            this.user = null;
        } else {
            this.user = userData
            this.setError(null)
        }
    };

    acceptPolicy = async () => {
        try {
            await acceptPolicyRequest();
            await this.refresh();
        } catch (err) {
            this.setError('Failed to accept policy')
        }
    };

    setNameAndRole = async (name, role) => {
        try {
            await setNameAndRoleRequest(name, role);
            await this.refresh();
        } catch (err) {
            this.setError('Failed to set name');
        }
    };

    logout() {
        this.isLoading = true
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('privy_id');
        localStorage.removeItem('id');
        this.user = null;
        this.token = null;
    }

    setIsLoading(value) {
        this.isLoading = value
    }

    setError(error) {
        this.root.setError(error)
    }

    isAuthenticated() {
        return this.token != null && !this.isLoading && this.user != null
    }

    isFree() {
        return this.user?.subscription === 'Free'
    }

    isPremium() {
        return !this.isFree()
    }

    // ENROLL
    scanCount = parseInt(localStorage.getItem('scanCount') || '0', 10);

    enrollUser = async () => {
        try {
            await enrollUserRequest();
            await this.refresh();
        } catch (err) {
            this.setError('Failed to enroll user')
        }
    };

    enroll = async (send_request = true, name = '') => {
        await this.enrollUser();
        if (send_request) {
            await sendSubscribeRequest(true, name);
        }
        logEvent('free_premium__enroll');
        await this.refresh();
    }

    isEnrolled() {
        return !!this.user?.enrolled
    }

    incrementEnrollCount() {
        this.scanCount += 1
        localStorage.setItem('scanCount', this.scanCount.toString());
    }

    shouldShowEnrollModal() {
        const user = this.user
        return !this.isEnrolled() &&
            (user?.scan_count === 2 || user?.scan_count === 9) &&
            this.isFree();
    }
}